export const profileMenuItems = [
  { translationKey: 'profile', subpath: 'information' },
  { translationKey: 'orders', subpath: 'orders' },
  { translationKey: 'wishlist', subpath: 'wishlist' },
  { translationKey: 'auctionBids', subpath: 'bids' },
  { translationKey: 'myDestinations', subpath: 'destinations' },
  { translationKey: 'proposals', subpath: 'proposals' },
]
